// AUTO-GENERATED messy demo diagram — a reasonable request pipeline made messy
// (tilted boxes, jittered positions, mixed stroke widths / font sizes / families,
// dashed strokes). '美化' straightens, aligns to columns, unifies styles, reconnects arrows.
import type { ExcalidrawElement } from "@excalidraw/element/types";

export const MESSY_SEED_ELEMENTS = [
  {
    id: "req-145167",
    type: "rectangle",
    x: 473.92,
    y: 104.97,
    width: 245.04,
    height: 82.27199999999999,
    angle: 0.030800000000000008,
    strokeColor: "#1e1e1e",
    backgroundColor: "transparent",
    fillStyle: "solid",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    groupIds: [],
    frameId: null,
    index: null,
    roundness: {
      type: 3,
    },
    seed: 287095136,
    version: 1,
    versionNonce: 487007017,
    isDeleted: false,
    boundElements: [
      {
        id: "t-req-145167",
        type: "text",
      },
      {
        id: "a-1824512",
        type: "arrow",
      },
    ],
    updated: 1,
    link: null,
    locked: false,
  },
  {
    id: "t-req-145167",
    type: "text",
    x: 485.92,
    y: 137.106,
    width: 221.04,
    height: 22.5,
    angle: 0.030800000000000008,
    strokeColor: "#1e1e1e",
    backgroundColor: "transparent",
    fillStyle: "solid",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    groupIds: [],
    frameId: null,
    index: null,
    roundness: null,
    seed: 1807787751,
    version: 1,
    versionNonce: 884048008,
    isDeleted: false,
    boundElements: [],
    updated: 1,
    link: null,
    locked: false,
    text: "用户请求",
    fontSize: 18,
    fontFamily: 5,
    textAlign: "center",
    verticalAlign: "middle",
    containerId: "req-145167",
    originalText: "用户请求",
    lineHeight: 1.25,
    autoResize: true,
  },
  {
    id: "gw-107471",
    type: "rectangle",
    x: 514.0,
    y: 295.43,
    width: 240.4,
    height: 78.88,
    angle: 0.032119999999999996,
    strokeColor: "#1e1e1e",
    backgroundColor: "transparent",
    fillStyle: "solid",
    strokeWidth: 4,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    groupIds: [],
    frameId: null,
    index: null,
    roundness: {
      type: 3,
    },
    seed: 1197764485,
    version: 1,
    versionNonce: 294197411,
    isDeleted: false,
    boundElements: [
      {
        id: "t-gw-107471",
        type: "text",
      },
      {
        id: "a-1824512",
        type: "arrow",
      },
      {
        id: "a-8529679",
        type: "arrow",
      },
      {
        id: "a-9339465",
        type: "arrow",
      },
    ],
    updated: 1,
    link: null,
    locked: false,
  },
  {
    id: "t-gw-107471",
    type: "text",
    x: 526.0,
    y: 325.87,
    width: 216.4,
    height: 22.5,
    angle: 0.032119999999999996,
    strokeColor: "#1e1e1e",
    backgroundColor: "transparent",
    fillStyle: "solid",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    groupIds: [],
    frameId: null,
    index: null,
    roundness: null,
    seed: 221524624,
    version: 1,
    versionNonce: 1985486769,
    isDeleted: false,
    boundElements: [],
    updated: 1,
    link: null,
    locked: false,
    text: "API 网关",
    fontSize: 18,
    fontFamily: 5,
    textAlign: "center",
    verticalAlign: "middle",
    containerId: "gw-107471",
    originalText: "API 网关",
    lineHeight: 1.25,
    autoResize: true,
  },
  {
    id: "auth-121125",
    type: "rectangle",
    x: 873.44,
    y: 282.29,
    width: 174.32,
    height: 88.544,
    angle: 0.035199999999999995,
    strokeColor: "#1e1e1e",
    backgroundColor: "transparent",
    fillStyle: "solid",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    groupIds: [],
    frameId: null,
    index: null,
    roundness: {
      type: 3,
    },
    seed: 1046270369,
    version: 1,
    versionNonce: 1112376348,
    isDeleted: false,
    boundElements: [
      {
        id: "t-auth-121125",
        type: "text",
      },
      {
        id: "a-8529679",
        type: "arrow",
      },
    ],
    updated: 1,
    link: null,
    locked: false,
  },
  {
    id: "t-auth-121125",
    type: "text",
    x: 885.44,
    y: 318.562,
    width: 150.32,
    height: 20.0,
    angle: 0.035199999999999995,
    strokeColor: "#1e1e1e",
    backgroundColor: "transparent",
    fillStyle: "solid",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    groupIds: [],
    frameId: null,
    index: null,
    roundness: null,
    seed: 534226084,
    version: 1,
    versionNonce: 1106486321,
    isDeleted: false,
    boundElements: [],
    updated: 1,
    link: null,
    locked: false,
    text: "鉴权服务",
    fontSize: 16,
    fontFamily: 8,
    textAlign: "center",
    verticalAlign: "middle",
    containerId: "auth-121125",
    originalText: "鉴权服务",
    lineHeight: 1.25,
    autoResize: true,
  },
  {
    id: "svc-117564",
    type: "rectangle",
    x: 547.12,
    y: 503.71,
    width: 217.68,
    height: 91.29599999999999,
    angle: 0.008360000000000006,
    strokeColor: "#1e1e1e",
    backgroundColor: "transparent",
    fillStyle: "solid",
    strokeWidth: 4,
    strokeStyle: "solid",
    roughness: 2,
    opacity: 100,
    groupIds: [],
    frameId: null,
    index: null,
    roundness: {
      type: 3,
    },
    seed: 1221930344,
    version: 1,
    versionNonce: 1131939346,
    isDeleted: false,
    boundElements: [
      {
        id: "t-svc-117564",
        type: "text",
      },
      {
        id: "a-9339465",
        type: "arrow",
      },
      {
        id: "a-1159508",
        type: "arrow",
      },
      {
        id: "a-9102963",
        type: "arrow",
      },
      {
        id: "a-8113284",
        type: "arrow",
      },
    ],
    updated: 1,
    link: null,
    locked: false,
  },
  {
    id: "t-svc-117564",
    type: "text",
    x: 559.12,
    y: 540.358,
    width: 193.68,
    height: 22.5,
    angle: 0.008360000000000006,
    strokeColor: "#1e1e1e",
    backgroundColor: "transparent",
    fillStyle: "solid",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    groupIds: [],
    frameId: null,
    index: null,
    roundness: null,
    seed: 797500123,
    version: 1,
    versionNonce: 82399972,
    isDeleted: false,
    boundElements: [],
    updated: 1,
    link: null,
    locked: false,
    text: "业务逻辑",
    fontSize: 18,
    fontFamily: 2,
    textAlign: "center",
    verticalAlign: "middle",
    containerId: "svc-117564",
    originalText: "业务逻辑",
    lineHeight: 1.25,
    autoResize: true,
  },
  {
    id: "cache-107939",
    type: "rectangle",
    x: 142.08,
    y: 486.97,
    width: 227.12,
    height: 85.6,
    angle: 0.07303999999999998,
    strokeColor: "#1e1e1e",
    backgroundColor: "transparent",
    fillStyle: "solid",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    groupIds: [],
    frameId: null,
    index: null,
    roundness: {
      type: 3,
    },
    seed: 1743980248,
    version: 1,
    versionNonce: 1530158740,
    isDeleted: false,
    boundElements: [
      {
        id: "t-cache-107939",
        type: "text",
      },
      {
        id: "a-1159508",
        type: "arrow",
      },
    ],
    updated: 1,
    link: null,
    locked: false,
  },
  {
    id: "t-cache-107939",
    type: "text",
    x: 154.08,
    y: 520.77,
    width: 203.12,
    height: 22.5,
    angle: 0.07303999999999998,
    strokeColor: "#1e1e1e",
    backgroundColor: "transparent",
    fillStyle: "solid",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    groupIds: [],
    frameId: null,
    index: null,
    roundness: null,
    seed: 1534477085,
    version: 1,
    versionNonce: 940965443,
    isDeleted: false,
    boundElements: [],
    updated: 1,
    link: null,
    locked: false,
    text: "缓存 Redis",
    fontSize: 18,
    fontFamily: 2,
    textAlign: "center",
    verticalAlign: "middle",
    containerId: "cache-107939",
    originalText: "缓存 Redis",
    lineHeight: 1.25,
    autoResize: true,
  },
  {
    id: "db-167659",
    type: "rectangle",
    x: 964.88,
    y: 492.55,
    width: 203.92000000000002,
    height: 78.368,
    angle: -0.09108,
    strokeColor: "#1e1e1e",
    backgroundColor: "transparent",
    fillStyle: "solid",
    strokeWidth: 4,
    strokeStyle: "solid",
    roughness: 2,
    opacity: 100,
    groupIds: [],
    frameId: null,
    index: null,
    roundness: {
      type: 3,
    },
    seed: 686331591,
    version: 1,
    versionNonce: 465843639,
    isDeleted: false,
    boundElements: [
      {
        id: "t-db-167659",
        type: "text",
      },
      {
        id: "a-9102963",
        type: "arrow",
      },
    ],
    updated: 1,
    link: null,
    locked: false,
  },
  {
    id: "t-db-167659",
    type: "text",
    x: 976.88,
    y: 521.734,
    width: 179.92000000000002,
    height: 25.0,
    angle: -0.09108,
    strokeColor: "#1e1e1e",
    backgroundColor: "transparent",
    fillStyle: "solid",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    groupIds: [],
    frameId: null,
    index: null,
    roundness: null,
    seed: 259138785,
    version: 1,
    versionNonce: 1423379759,
    isDeleted: false,
    boundElements: [],
    updated: 1,
    link: null,
    locked: false,
    text: "数据库",
    fontSize: 20,
    fontFamily: 1,
    textAlign: "center",
    verticalAlign: "middle",
    containerId: "db-167659",
    originalText: "数据库",
    lineHeight: 1.25,
    autoResize: true,
  },
  {
    id: "llm-124480",
    type: "rectangle",
    x: 511.84,
    y: 684.45,
    width: 179.44,
    height: 87.264,
    angle: 0.05456000000000001,
    strokeColor: "#1e1e1e",
    backgroundColor: "transparent",
    fillStyle: "solid",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    groupIds: [],
    frameId: null,
    index: null,
    roundness: {
      type: 3,
    },
    seed: 388136039,
    version: 1,
    versionNonce: 920843399,
    isDeleted: false,
    boundElements: [
      {
        id: "t-llm-124480",
        type: "text",
      },
      {
        id: "a-8113284",
        type: "arrow",
      },
      {
        id: "a-1647400",
        type: "arrow",
      },
    ],
    updated: 1,
    link: null,
    locked: false,
  },
  {
    id: "t-llm-124480",
    type: "text",
    x: 523.8399999999999,
    y: 720.082,
    width: 155.44,
    height: 20.0,
    angle: 0.05456000000000001,
    strokeColor: "#1e1e1e",
    backgroundColor: "transparent",
    fillStyle: "solid",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    groupIds: [],
    frameId: null,
    index: null,
    roundness: null,
    seed: 1816110977,
    version: 1,
    versionNonce: 136826856,
    isDeleted: false,
    boundElements: [],
    updated: 1,
    link: null,
    locked: false,
    text: "LLM 模型",
    fontSize: 16,
    fontFamily: 2,
    textAlign: "center",
    verticalAlign: "middle",
    containerId: "llm-124480",
    originalText: "LLM 模型",
    lineHeight: 1.25,
    autoResize: true,
  },
  {
    id: "agg-150333",
    type: "rectangle",
    x: 526.96,
    y: 933.23,
    width: 220.88,
    height: 67.232,
    angle: -0.021559999999999996,
    strokeColor: "#1e1e1e",
    backgroundColor: "transparent",
    fillStyle: "solid",
    strokeWidth: 4,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    groupIds: [],
    frameId: null,
    index: null,
    roundness: {
      type: 3,
    },
    seed: 1104276512,
    version: 1,
    versionNonce: 1182048639,
    isDeleted: false,
    boundElements: [
      {
        id: "t-agg-150333",
        type: "text",
      },
      {
        id: "a-1647400",
        type: "arrow",
      },
      {
        id: "a-5307826",
        type: "arrow",
      },
    ],
    updated: 1,
    link: null,
    locked: false,
  },
  {
    id: "t-agg-150333",
    type: "text",
    x: 538.96,
    y: 954.846,
    width: 196.88,
    height: 30.0,
    angle: -0.021559999999999996,
    strokeColor: "#1e1e1e",
    backgroundColor: "transparent",
    fillStyle: "solid",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    groupIds: [],
    frameId: null,
    index: null,
    roundness: null,
    seed: 486206754,
    version: 1,
    versionNonce: 1949687091,
    isDeleted: false,
    boundElements: [],
    updated: 1,
    link: null,
    locked: false,
    text: "结果聚合",
    fontSize: 24,
    fontFamily: 8,
    textAlign: "center",
    verticalAlign: "middle",
    containerId: "agg-150333",
    originalText: "结果聚合",
    lineHeight: 1.25,
    autoResize: true,
  },
  {
    id: "resp-181911",
    type: "rectangle",
    x: 476.8,
    y: 1143.85,
    width: 235.44,
    height: 80.48,
    angle: -0.043120000000000006,
    strokeColor: "#1e1e1e",
    backgroundColor: "transparent",
    fillStyle: "solid",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    groupIds: [],
    frameId: null,
    index: null,
    roundness: {
      type: 3,
    },
    seed: 29004317,
    version: 1,
    versionNonce: 1219197244,
    isDeleted: false,
    boundElements: [
      {
        id: "t-resp-181911",
        type: "text",
      },
      {
        id: "a-5307826",
        type: "arrow",
      },
    ],
    updated: 1,
    link: null,
    locked: false,
  },
  {
    id: "t-resp-181911",
    type: "text",
    x: 488.8,
    y: 1175.09,
    width: 211.44,
    height: 22.5,
    angle: -0.043120000000000006,
    strokeColor: "#1e1e1e",
    backgroundColor: "transparent",
    fillStyle: "solid",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    groupIds: [],
    frameId: null,
    index: null,
    roundness: null,
    seed: 1182234406,
    version: 1,
    versionNonce: 1784925204,
    isDeleted: false,
    boundElements: [],
    updated: 1,
    link: null,
    locked: false,
    text: "返回响应",
    fontSize: 18,
    fontFamily: 5,
    textAlign: "center",
    verticalAlign: "middle",
    containerId: "resp-181911",
    originalText: "返回响应",
    lineHeight: 1.25,
    autoResize: true,
  },
  {
    id: "a-1824512",
    type: "arrow",
    x: 596.44,
    y: 146.106,
    width: 37.75999999999999,
    height: 188.764,
    angle: 0,
    strokeColor: "#1e1e1e",
    backgroundColor: "transparent",
    fillStyle: "solid",
    strokeWidth: 3,
    strokeStyle: "dashed",
    roughness: 1,
    opacity: 100,
    groupIds: [],
    frameId: null,
    index: null,
    roundness: {
      type: 2,
    },
    seed: 567472448,
    version: 1,
    versionNonce: 1418853007,
    isDeleted: false,
    boundElements: [],
    updated: 1,
    link: null,
    locked: false,
    points: [
      [0, 0],
      [37.75999999999999, 188.764],
    ],
    lastCommittedPoint: null,
    startBinding: {
      elementId: "req-145167",
      focus: 0,
      gap: 4,
    },
    endBinding: {
      elementId: "gw-107471",
      focus: 0,
      gap: 4,
    },
    startArrowhead: null,
    endArrowhead: "arrow",
  },
  {
    id: "a-8529679",
    type: "arrow",
    x: 634.2,
    y: 334.87,
    width: 326.4,
    height: -8.307999999999993,
    angle: 0,
    strokeColor: "#1e1e1e",
    backgroundColor: "transparent",
    fillStyle: "solid",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 2,
    opacity: 100,
    groupIds: [],
    frameId: null,
    index: null,
    roundness: {
      type: 2,
    },
    seed: 535274098,
    version: 1,
    versionNonce: 1350433973,
    isDeleted: false,
    boundElements: [],
    updated: 1,
    link: null,
    locked: false,
    points: [
      [0, 0],
      [326.4, -8.307999999999993],
    ],
    lastCommittedPoint: null,
    startBinding: {
      elementId: "gw-107471",
      focus: 0,
      gap: 4,
    },
    endBinding: {
      elementId: "auth-121125",
      focus: 0,
      gap: 4,
    },
    startArrowhead: null,
    endArrowhead: "arrow",
  },
  {
    id: "a-9339465",
    type: "arrow",
    x: 634.2,
    y: 334.87,
    width: 21.75999999999999,
    height: 214.48799999999994,
    angle: 0,
    strokeColor: "#1e1e1e",
    backgroundColor: "transparent",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    groupIds: [],
    frameId: null,
    index: null,
    roundness: {
      type: 2,
    },
    seed: 849782818,
    version: 1,
    versionNonce: 434790440,
    isDeleted: false,
    boundElements: [],
    updated: 1,
    link: null,
    locked: false,
    points: [
      [0, 0],
      [21.75999999999999, 214.48799999999994],
    ],
    lastCommittedPoint: null,
    startBinding: {
      elementId: "gw-107471",
      focus: 0,
      gap: 4,
    },
    endBinding: {
      elementId: "svc-117564",
      focus: 0,
      gap: 4,
    },
    startArrowhead: null,
    endArrowhead: "arrow",
  },
  {
    id: "a-1159508",
    type: "arrow",
    x: 655.96,
    y: 549.358,
    width: -400.32000000000005,
    height: -19.587999999999965,
    angle: 0,
    strokeColor: "#1e1e1e",
    backgroundColor: "transparent",
    fillStyle: "solid",
    strokeWidth: 4,
    strokeStyle: "solid",
    roughness: 2,
    opacity: 100,
    groupIds: [],
    frameId: null,
    index: null,
    roundness: {
      type: 2,
    },
    seed: 287248445,
    version: 1,
    versionNonce: 609644396,
    isDeleted: false,
    boundElements: [],
    updated: 1,
    link: null,
    locked: false,
    points: [
      [0, 0],
      [-400.32000000000005, -19.587999999999965],
    ],
    lastCommittedPoint: null,
    startBinding: {
      elementId: "svc-117564",
      focus: 0,
      gap: 4,
    },
    endBinding: {
      elementId: "cache-107939",
      focus: 0,
      gap: 4,
    },
    startArrowhead: null,
    endArrowhead: "arrow",
  },
  {
    id: "a-9102963",
    type: "arrow",
    x: 655.96,
    y: 549.358,
    width: 410.8799999999999,
    height: -17.62399999999991,
    angle: 0,
    strokeColor: "#1e1e1e",
    backgroundColor: "transparent",
    fillStyle: "solid",
    strokeWidth: 3,
    strokeStyle: "dashed",
    roughness: 1,
    opacity: 100,
    groupIds: [],
    frameId: null,
    index: null,
    roundness: {
      type: 2,
    },
    seed: 597864188,
    version: 1,
    versionNonce: 1482152296,
    isDeleted: false,
    boundElements: [],
    updated: 1,
    link: null,
    locked: false,
    points: [
      [0, 0],
      [410.8799999999999, -17.62399999999991],
    ],
    lastCommittedPoint: null,
    startBinding: {
      elementId: "svc-117564",
      focus: 0,
      gap: 4,
    },
    endBinding: {
      elementId: "db-167659",
      focus: 0,
      gap: 4,
    },
    startArrowhead: null,
    endArrowhead: "arrow",
  },
  {
    id: "a-8113284",
    type: "arrow",
    x: 655.96,
    y: 549.358,
    width: -54.40000000000009,
    height: 178.72400000000005,
    angle: 0,
    strokeColor: "#1e1e1e",
    backgroundColor: "transparent",
    fillStyle: "solid",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 2,
    opacity: 100,
    groupIds: [],
    frameId: null,
    index: null,
    roundness: {
      type: 2,
    },
    seed: 1470184798,
    version: 1,
    versionNonce: 1944639333,
    isDeleted: false,
    boundElements: [],
    updated: 1,
    link: null,
    locked: false,
    points: [
      [0, 0],
      [-54.40000000000009, 178.72400000000005],
    ],
    lastCommittedPoint: null,
    startBinding: {
      elementId: "svc-117564",
      focus: 0,
      gap: 4,
    },
    endBinding: {
      elementId: "llm-124480",
      focus: 0,
      gap: 4,
    },
    startArrowhead: null,
    endArrowhead: "arrow",
  },
  {
    id: "a-1647400",
    type: "arrow",
    x: 601.56,
    y: 728.082,
    width: 35.840000000000146,
    height: 238.764,
    angle: 0,
    strokeColor: "#1e1e1e",
    backgroundColor: "transparent",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    groupIds: [],
    frameId: null,
    index: null,
    roundness: {
      type: 2,
    },
    seed: 62032716,
    version: 1,
    versionNonce: 277561409,
    isDeleted: false,
    boundElements: [],
    updated: 1,
    link: null,
    locked: false,
    points: [
      [0, 0],
      [35.840000000000146, 238.764],
    ],
    lastCommittedPoint: null,
    startBinding: {
      elementId: "llm-124480",
      focus: 0,
      gap: 4,
    },
    endBinding: {
      elementId: "agg-150333",
      focus: 0,
      gap: 4,
    },
    startArrowhead: null,
    endArrowhead: "arrow",
  },
  {
    id: "a-5307826",
    type: "arrow",
    x: 637.4000000000001,
    y: 966.846,
    width: -42.88000000000011,
    height: 217.24399999999991,
    angle: 0,
    strokeColor: "#1e1e1e",
    backgroundColor: "transparent",
    fillStyle: "solid",
    strokeWidth: 4,
    strokeStyle: "solid",
    roughness: 2,
    opacity: 100,
    groupIds: [],
    frameId: null,
    index: null,
    roundness: {
      type: 2,
    },
    seed: 1103173808,
    version: 1,
    versionNonce: 379868059,
    isDeleted: false,
    boundElements: [],
    updated: 1,
    link: null,
    locked: false,
    points: [
      [0, 0],
      [-42.88000000000011, 217.24399999999991],
    ],
    lastCommittedPoint: null,
    startBinding: {
      elementId: "agg-150333",
      focus: 0,
      gap: 4,
    },
    endBinding: {
      elementId: "resp-181911",
      focus: 0,
      gap: 4,
    },
    startArrowhead: null,
    endArrowhead: "arrow",
  },
] as unknown as ExcalidrawElement[];

export const MESSY_SEED_APP_STATE = { viewBackgroundColor: "#ffffff" };
